import React from 'react';

import { box, CONTENT_WIDTH, CONTENTS_ENTRY_HEIGHT, CONTENTS_NUMBER_WIDTH, CONTENTS_TAG_WIDTH, MARGIN_X, pt } from '../slideGeometry';

/**
 * The contents list: one row per section page, with its first slide number, each as tall as the
 * Paginator fitted it (`fit.height`), its tag at `fit.tagSize` and its title wrapping.
 */
const ContentsBlock = ({ block }) => {
    const entries = block.entries || [];

    if (!entries.length) {
        return (
            <div className="tw-italic tw-text-charcoal-60" style={{ ...box(MARGIN_X, block.y + 5, CONTENT_WIDTH, 18), fontSize: pt(10) }}>
                {block.emptyMessage}
            </div>
        );
    }

    let top = block.y;

    return entries.map((entry, index) => {
        const height = entry.fit?.height ?? CONTENTS_ENTRY_HEIGHT;
        const y = top;
        top += height;

        return (
            <div key={index} className="tw-flex tw-items-center tw-border-b tw-border-charcoal-15" style={box(MARGIN_X, y, CONTENT_WIDTH, height)}>
                <span
                    className="tw-text-blue tw-font-bold tw-uppercase tw-shrink-0"
                    style={{ width: CONTENTS_TAG_WIDTH, fontSize: pt(entry.fit?.tagSize ?? 9) }}
                >
                    {entry.sectionTag}
                </span>
                <span className="tw-text-charcoal tw-flex-1" style={{ fontSize: pt(11) }}>
                    {entry.title}
                </span>
                <span className="tw-text-charcoal tw-font-bold tw-text-end tw-shrink-0" style={{ width: CONTENTS_NUMBER_WIDTH, fontSize: pt(11) }}>
                    {entry.pageNumber}
                </span>
            </div>
        );
    });
};

export default ContentsBlock;
